module.exports = __webpack_public_path__ + "img/placeholder_3_16to9.c588e392.svg";